export { default } from './CoverImage'
export type { CoverImageProps } from './CoverImage'
